import Api from '@/api/apiErp/apiErpUser';
import apiUserService from '@/services/api/common/userService';

export default {
  async createUser({ commit }, params) {
    try {
      return await Api.addUser(params);
    } catch (e) {
      console.log(e);
      this.$store.dispatch('errorHandler/throwError', { detail: 'Cette addresse mail est déja affectée à un accès STUDIO.' });
      return null;
    }
  },
  async getUser({ commit }, { contactId }) {
    const user = await apiUserService.getById(contactId);
    commit('contacts/setSelectedContact', user, { root: true });
    commit('app/setFocusedObject', user, { root: true });
  },
};
